// src/com/auto_plan/AutoPlanGql.js
import { gql } from "@apollo/client";

/*
extend type Mutation {
	autoPlanBuild(autoPlan: InputAutoPlanBuild!): CommonResponse!
}

input InputAutoPlanBuild {
	planDate: String!
}

*/

export const BUILD_AUTO_PLAN = gql`
mutation BuildAutoPlan($autoPlan: InputAutoPlanBuild!) {
    autoPlanBuild(autoPlan: $autoPlan) {
        ok
        message
    }
}
`;

